import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

import { useSelector } from 'react-redux';
import { hideAlert, showAlert } from "../../../core-module/services/errorAlert/reducers"
import { useDispatch } from 'react-redux'
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

function ApiAlert(props) {
  const classes = {
    button: {
      marginRight: "8px",
      boxShadow: "rgb(0 0 0 / 8%) 0px 1px 1px inset, rgb(165 202 234) 0px 0px 8px",
      backgroundColor: "#4caf50",
      color: "#FFF",
      cursor: "pointer",
      margin: ".3125rem 1px",
      padding: "12px 30px",
      fontSize: "12px",
      fontWeight: "400"
    }
  };
  const dispatch = useDispatch();
  let shouldAppear = useSelector(state => state.services.errorAlert.showAlert)
  let message = useSelector(state => state.services.errorAlert.text)
  var stringType = isString(props.message)
  var json = props.message ? stringType ? props.message : JSON.parse(props.message) : props.message

  let alertText = message? message : stringType ? json : json.message;

  let fnctn = props.function ? props.function : null

  function handleConfirm () {
    if (fnctn) {
      fnctn()
    }
    dispatch(hideAlert())
  }

  function isString(value) {
    return value.indexOf('{') == 0 ? false : true;
  }

  return (
    <div>
      {shouldAppear ? (
        <SweetAlert
            error
            style={{
              display: "block",
              top: "5%",
              maxWidth: "90%",
              marginTop: "1%",
            }}
            title={"Error"}
            onConfirm={() => handleConfirm()}
            confirmBtnStyle={{marginRight: "8px",
            boxShadow: "rgb(0 0 0 / 8%) 0px 1px 1px inset, rgb(165 202 234) 0px 0px 8px",
            backgroundColor: "#4caf50",
            color: "#FFF",
            cursor: "pointer",
            margin: ".3125rem 1px",
            padding: "12px 30px",
            fontSize: "12px",
            fontWeight: "400"}}
            confirmBtnText="DISMISS"
          >
            <p>{alertText}</p>
          </SweetAlert>
          ) : (
          null
      )}
    </div>
  );
}
export default (ApiAlert);
